import { createUseStyles } from 'react-jss'
import { forPhoneOnly } from 'src/config/mediaQueries'
import { Theme } from '@mui/material/styles'

export default createUseStyles((theme: Theme) => ({
  toggleClinicsContainer: {
    scrollMarginTop: '80px',

    [forPhoneOnly]: {
      padding: [0, 16],
      scrollMarginTop: '110px',
    },
  },
  toggleShowMoreClinics: {
    cursor: 'pointer',
    color: theme.palette.primary[900],
    background: theme.palette.primary[100],
    borderRadius: '8px',
    marginBottom: 32,
    [forPhoneOnly]: {
      marginBottom: 24,
    },
  },
  expandIcon: { marginLeft: 8, transition: 'all 0.4s' },
  expandedIcon: {
    transform: 'rotate(180deg)',
  },
}))
